module.exports = __webpack_public_path__ + "static/peaks_prints-67c1ad94a02b75bef46d882e569ddf28.png";